<template>
    <div class="w-full px-4 py-1" :class="{'bg-grey-darker': active}" v-if="message !== null" v-on:mouseover="mouseOver" v-on:mouseout="mouseOver">
        <!-- <span class="text-blue"><i class="fas fa-badge-check"></i></span> -->
        <span class="inline-block">
            <i class="fas fa-user-crown text-red mr-1" v-if="message.sender.role == 'administrator' || message.sender.role == 'chaser' || message.sender.role == 'network'"></i>
            <!-- <i class="fas fa-user-shield text-blue mr-1" v-if="message.sender.role == 'administrator'"></i> -->
        </span>
        <span>{{ message.created_at | displayMessageTime }} </span> <span class="font-bold">{{ message.sender.username }}</span> <span>: &nbsp;</span> <span>{{ message.message }}</span>
        <div class="float-right" v-show="active" v-if="determineIfAbleToDelete()">
            <i class="fa fa-trash" v-on:click="removeMessage()"></i>
        </div>
    </div>



</template>

<script>
    import * as Config from '@/config'
    import { mapState, mapGetters } from 'vuex';
    import moment from 'moment'

    export default {
        name: 'ChatMessage',
        data() {
            return {
                active: false,
            }
        },
        props: [
            'message'
        ],
        computed: {
			...mapGetters([
                'userInfo',
            ]),
        },
        methods: {
            ...mapGetters([
                'getAuthorizationHeader',
                'isAuthenticated'
            ]),
            mouseOver() {
                this.active = !this.active
            },
            parseRole(role) {
                if(role == 'administrator' || role == 'network' || role == 'chaser') {
                    return true
                }
                return false
            },
            removeMessage() {
                var _this = this
                this.$http.delete(Config.apiPath + "/api/v1/chat/" + this.message.channel + "/messages/" + this.message.id, {
                    data: {
                        message: _this.message
                    },
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': 'Bearer ' + localStorage.getItem('access_token')
                    }
                }).then((response) => {

                });
            },
            determineIfAbleToDelete() {
                if(this.isAuthenticated() && (this.userInfo !== undefined)) {
                    if(this.userInfo.role == 'administrator' || this.userInfo.role == 'network' || this.userInfo.role == 'chaser') {
                        return true
                    }
                }
                return false
            }
        },
        filters: {
            displayMessageTime: function(date) {
                return moment.utc(date).local().format('h:mm');
            },

        }
    }
</script>

<style>
    nav a {
      text-decoration: none;
    }
    #message {
        resize: none;
    }
</style>
